import moment from 'moment';
import React, { Component } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { BsCard, BsFormControl, BsFormSelect, BsFormWithButtons } from '../../collection/bootstrap/BootstrapComponents';
import Loading from '../../collection/icons/Loading';
import { apiForm, apiGet } from '../../utils/api';
import { validateEmail } from '../../utils/functions';
import { swalert } from '../../utils/notifications';

export default function HookUsuario(props) {
    const navigate = useNavigate();
    return <Usuario {...useParams()} {...props} navigate={navigate} />
}

export class Usuario extends Component {

    constructor(props) {
        super(props);
        this.updateData = this.updateData.bind(this);
        this.checkData = this.checkData.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    async updateData() {
        let user = await apiGet(`usuarios/get/${this.props.idUsuario}`);
        if (user) {
            let inicioContrato = moment(user.inicioContrato);
            user.inicioContrato = inicioContrato.isValid() ? inicioContrato.format("YYYY-MM-DD") : null;
            let finContrato = moment(user.finContrato);
            user.finContrato = finContrato.isValid() ? finContrato.format("YYYY-MM-DD") : null;
        }
        return user;
    }

    checkData(formData) {
        let errors = {};
        // Nombre
        const name = formData.get("name");
        if (!name) {
            errors["name"] = "Campo obligatorio";
        }
        // Apellidos
        const apellidos = formData.get("apellidos");
        if (!apellidos) {
            errors["apellidos"] = "Campo obligatorio";
        }
        // Email
        const email = formData.get("email");
        if (!email) {
            errors["email"] = "Campo obligatorio";
        } else if (!validateEmail(email)) {
            errors["email"] = "Formato de email no válido";
        }
        // Convenio
        const convenio = formData.get("convenio");
        if (!convenio) {
            errors["convenio"] = "Campo obligatorio";
        }
        // Localidad
        const localidad = formData.get("localidad");
        if (!localidad) {
            errors["localidad"] = "Campo obligatorio";
        }
        // Ceco
        const ceco = formData.get("ceco");
        if (!ceco) {
            errors["ceco"] = "Campo obligatorio";
        }
        // Username
        const username = formData.get("username");
        if (!username) {
            errors["username"] = "Campo obligatorio";
        }
        // Contraseña
        const password = formData.get("password");
        if (this.props.new && !password) {
            errors["password"] = "Campo obligatorio";
        }
        // Confirmar contraseña
        const confirmPassword = formData.get("confirmPassword");
        if ((password || confirmPassword) && password !== confirmPassword) {
            errors["confirmPassword"] = "Las contraseñas no coinciden";
        }
        return errors;
    }

    async saveData(data) {
        const action = this.props.new ? "new" : "edit";
        const result = await apiForm("usuarios/" + action, data);
        if (result) {
            swalert("Guardado", "Usuario guardado con éxito", "success");
            this.props.navigate('../usuarios');
        }
    }

    render() {
        return (
            <>
                <h2>{this.props.new ? "Nuevo usuario" : "Editar usuario"}</h2>
                <BsFormWithButtons
                    isNew={this.props.new}
                    onUpdate={this.updateData}
                    onCheck={this.checkData}
                    onSave={this.saveData}
                    backBtnLink="../usuarios">
                    <UsuarioForm />
                </BsFormWithButtons>
            </>
        );
    }
}

class UsuarioForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            listDepartamentos: null,
            listConvenios: null,
            listLocalidades: null,
            isLoading: true
        };
    }

    componentDidMount() {
        this.updateData();
    }

    async updateData() {
        this.setState({
            listDepartamentos: await apiGet("departamentos/list"),
            listConvenios: await apiGet("convenios/list"),
            listLocalidades: await apiGet("localidades/list"),
            isLoading: false
        });
    }

    renderForm() {
        const data = this.props.data;
        const errors = this.props.errors;
        return <>
            <BsCard header="Datos de acceso" className="mt-3">
                <Row className="gy-3">
                    <Col md="6">
                        <BsFormControl
                            /* Usuario */
                            label="Usuario" name="username"
                            value={data.username} error={errors.username}
                            maxLength="50" />
                    </Col>
                    <Col md="6">
                        <BsFormControl
                            /* Código PSA */
                            label="Código Tarjeta NFC" name="codigoPSA"
                            value={data.codigoPSA} error={errors.codigoPSA}
                            maxLength="14" />
                    </Col>
                    <Col md="6">
                        <BsFormControl
                            /* Contraseña */
                            label="Contraseña" name="password"
                            error={errors.password}
                            type="password" isNewPassword />
                    </Col>
                    <Col md="6">
                        <BsFormControl
                            /* Confirmar contraseña */
                            label="Confirmar contraseña" name="confirmPassword"
                            error={errors.confirmPassword}
                            type="password" isNewPassword />
                    </Col>
                    <Col md="3">
                        <Form.Check
                            /* Activo */
                            label="Activo" name="activo"
                            defaultChecked={data.activo || this.props.isNew} value="true"
                            type="switch" id="activo" />
                    </Col>
                    <Col md="3">
                        <Form.Check
                            /* Es Oficina */
                            label="Es Oficina?" name="esOficina"
                            defaultChecked={data.esOficina || this.props.isNew} value="true"
                            type="switch" id="esOficina" />
                    </Col>
                    <Col md="3">
                        <Form.Check
                            /* Permiso admin */
                            label="Administrador de plataforma" name="permisoAdmin"
                            defaultChecked={data.permisoAdmin} value="true"
                            type="switch" id="permisoAdmin" />
                    </Col>
                    <Col md="3">
                        <Form.Check
                            /* Permiso vestuario */
                            label="Administrador de vestuario" name="permisoVestuario"
                            defaultChecked={data.permisoVestuario} value="true"
                            type="switch" id="permisoVestuario" />
                    </Col>
                </Row>
            </BsCard>
            <BsCard header="Datos del trabajador" className="mt-3">
                <Row className="gy-3">
                    <Col md="6">
                        <BsFormControl
                            /* Nombre */
                            label="Nombre" name="name"
                            value={data.name} error={errors.name}
                            maxLength="50" />
                    </Col>
                    <Col md="6">
                        <BsFormControl
                            /* Apellidos */
                            label="Apellidos" name="apellidos"
                            value={data.apellidos} error={errors.apellidos}
                            maxLength="50" />
                    </Col>
                    <Col md="6">
                        <BsFormControl
                            /* Email */
                            label="Email" name="email"
                            value={data.email} error={errors.email}
                            maxLength="50" />
                    </Col>
                    <Col md="6">
                        <BsFormSelect
                            /* Departamento */
                            label="Departamento" name="departamento"
                            value={data.departamento} error={errors.departamento}
                            options={this.state.listDepartamentos}
                            isClearable />
                    </Col>
                    <Col md="6">
                        <BsFormSelect
                            /* Convenio */
                            label="Convenio" name="convenio"
                            value={data.convenio} error={errors.convenio}
                            options={this.state.listConvenios} />
                    </Col>
                    <Col md="6">
                        <BsFormSelect
                            /* Localidad */
                            label="Localidad" name="localidad"
                            value={data.localidad} error={errors.localidad}
                            options={this.state.listLocalidades} />
                    </Col>
                    <Col md="6">
                        <BsFormControl
                            /* Inicio contrato */
                            label="Inicio del contrato" name="inicioContrato"
                            value={data.inicioContrato} error={errors.inicioContrato}
                            type="date" />
                    </Col>
                    <Col md="6">
                        <BsFormControl
                            /* Fin contrato */
                            label="Fin del contrato" name="finContrato"
                            value={data.finContrato} error={errors.finContrato}
                            type="date" />
                    </Col>
                    <Col md="6">
                        <BsFormControl
                            /* Ceco */
                            label="Centro de costes" name="ceco"
                            value={data.ceco} error={errors.ceco}
                            maxLength="50" />
                    </Col>
                </Row>
            </BsCard>
        </>;
    }

    render() {
        return this.state.isLoading ? <Loading /> : this.renderForm();
    }
}
